<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailHuiChangList"
      data-title="物料管理"
    >
      <el-segmented
        v-model="state.params.status"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[{ Text: '全部' }, ...$base.Common_Status]"
        class="c-segmented"
        @change="onLoad()"
      />
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />

        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="状态" label2="编号" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.intro">
              <template #top>
                <strong>{{ row.name }}</strong>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="创建信息" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.hotel?.name + '-' + row.hotelHall?.name">
              <template #top>
                <strong>{{ row.hotel?.address }}</strong>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :width="120" align="center">
          <template #header>
            <div class="c-table-col-header" label1="数量" label2="类型" />
          </template>
          <template #default="{ row }">
            <text>{{ row.richeng_count }}</text>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="负责人" label2="说明" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.hotel?.name + '-' + row.hotelHall?.name">
              <template #top>
                <strong>{{ row.hotel?.address }}</strong>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column lable="完成说明">
          <template #default="{ row }">
            <c_tabgroup :value2="row.hotel?.name + '-' + row.hotelHall?.name">
              <template #top>
                <strong>{{ row.hotel?.address }}</strong>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="success"
              :icon="Select"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              标记完成
            </el-button>
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              >编辑
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="`${state.selectId ? '编辑' : '新建'}物料`"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
    :width="500"
  >
    <c_info
      :meeting_id="props.meeting_id"
      :id="state.selectId"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_place_page, meeting_place_delete } from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      state.list_data = [{}];

      // meeting_place_page(state.params).then((res) => {
      //   if (res.status == 200) {
      //     const { list, count } = res.data?.data;
      //     state.tableData = list;
      //     state.totalCount = count;
      //   }
      // });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_place_delete, row.id, onLoad, {
        filed: "物料",
        name: row.name,
      });
    };

    return { state, props, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
